import { SagaIterator } from 'redux-saga';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { approveLimitV2Api, createDraftLimitV2Api, deleteLimitV2Api, deleteLimitV2ByExternalIdApi, freezeLimitV2Api, latestVersionLimitsV2Api, listApprovedLimitsV2Api, publishLimitV2Api, rejectLimitV2Api, sentBackLimitV2Api, unfreezeLimitV2Api, updateDraftLimitV2Api } from './api';
import { ApproveLimitV2Request, CreateDraftLimitV2Request, DeleteLimitV2ByExternalIdRequest, DeleteLimitV2Request, FreezeLimitV2Request, LatestVersionLimitsV2Request, LimitConfigV2ReduxTypes, ListApprovedLimitsV2Request, PublishLimitV2Request, RejectLimitV2Request, SentBackLimitV2Request, UnfreezeLimitV2Request, UpdateDraftLimitV2Request } from './types';

function* listApprovedLimitsV2({ payload }: ListApprovedLimitsV2Request): SagaIterator {
  try {
    const response = yield call(listApprovedLimitsV2Api, payload);
    yield put({
      type: LimitConfigV2ReduxTypes.FETCH_LIST_APPROVED_LIMITS_V2_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.FETCH_LIST_APPROVED_LIMITS_V2_ERROR,
      payload: { error },
    });
  }
}

function* watchListApprovedLimitsV2() {
  yield takeEvery(LimitConfigV2ReduxTypes.FETCH_LIST_APPROVED_LIMITS_V2, listApprovedLimitsV2);
}

function* latestVersionLimitsV2({ payload }: LatestVersionLimitsV2Request): SagaIterator {
  try {
    const response = yield call(latestVersionLimitsV2Api, payload);
    yield put({
      type: LimitConfigV2ReduxTypes.FETCH_LATEST_VERSION_LIMITS_V2_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.FETCH_LATEST_VERSION_LIMITS_V2_ERROR,
      payload: { error },
    });
  }
}

function* watchLatestVersionLimitsV2() {
  yield takeEvery(LimitConfigV2ReduxTypes.FETCH_LATEST_VERSION_LIMITS_V2, latestVersionLimitsV2);
}

function* createDraftLimitV2({ payload }: CreateDraftLimitV2Request): SagaIterator {
  try {
    const response = yield call(createDraftLimitV2Api, payload.customerExternalId, payload.data);
    yield put({
      type: LimitConfigV2ReduxTypes.CREATE_DRAFT_LIMIT_V2_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.CREATE_DRAFT_LIMIT_V2_ERROR,
      payload: { error },
    });
  }
}

function* watchCreateDraftLimitV2() {
  yield takeEvery(LimitConfigV2ReduxTypes.CREATE_DRAFT_LIMIT_V2, createDraftLimitV2);
}

function* publishLimitV2({ payload }: PublishLimitV2Request): SagaIterator {
  try {
    const response = yield call(publishLimitV2Api, payload.customerExternalId, payload.data);
    yield put({
      type: LimitConfigV2ReduxTypes.PUBLISH_LIMIT_V2_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.PUBLISH_LIMIT_V2_ERROR,
      payload: { error },
    });
  }
}

function* watchPublishLimitV2() {
  yield takeEvery(LimitConfigV2ReduxTypes.PUBLISH_LIMIT_V2, publishLimitV2);
}

function* updateDraftLimitV2({ payload }: UpdateDraftLimitV2Request): SagaIterator {
  try {
    const response = yield call(updateDraftLimitV2Api, payload.customerExternalId, payload.data);
    yield put({
      type: LimitConfigV2ReduxTypes.UPDATE_DRAFT_LIMIT_V2_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.UPDATE_DRAFT_LIMIT_V2_ERROR,
      payload: { error },
    });
  }
}

function* watchUpdateDraftLimitV2() {
  yield takeEvery(LimitConfigV2ReduxTypes.UPDATE_DRAFT_LIMIT_V2, updateDraftLimitV2);
}

function* approveLimitV2({ payload }: ApproveLimitV2Request): SagaIterator {
  try {
    const response = yield call(approveLimitV2Api, payload.customerExternalId, payload.data);
    yield put({
      type: LimitConfigV2ReduxTypes.APPROVE_LIMIT_V2_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.APPROVE_LIMIT_V2_ERROR,
      payload: { error },
    });
  }
}

function* watchApproveLimitV2() {
  yield takeEvery(LimitConfigV2ReduxTypes.APPROVE_LIMIT_V2, approveLimitV2);
}

function* rejectLimitV2({ payload }: RejectLimitV2Request): SagaIterator {
  try {
    const response = yield call(rejectLimitV2Api, payload.customerExternalId, payload.data);
    yield put({
      type: LimitConfigV2ReduxTypes.REJECT_LIMIT_V2_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.REJECT_LIMIT_V2_ERROR,
      payload: { error },
    });
  }
}

function* watchRejectLimitV2() {
  yield takeEvery(LimitConfigV2ReduxTypes.REJECT_LIMIT_V2, rejectLimitV2);
}

function* sentBackLimitV2({ payload }: SentBackLimitV2Request): SagaIterator {
  try {
    const response = yield call(sentBackLimitV2Api, payload.customerExternalId, payload.data);
    yield put({
      type: LimitConfigV2ReduxTypes.SENT_BACK_LIMIT_V2_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.SENT_BACK_LIMIT_V2_ERROR,
      payload: { error },
    });
  }
}

function* watchSentBackLimitV2() {
  yield takeEvery(LimitConfigV2ReduxTypes.SENT_BACK_LIMIT_V2, sentBackLimitV2);
}

function* deleteLimitV2({ payload }: DeleteLimitV2Request): SagaIterator {
  try {
    const response = yield call(deleteLimitV2Api, payload);
    yield put({
      type: LimitConfigV2ReduxTypes.DELETE_LIMIT_V2_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.DELETE_LIMIT_V2_ERROR,
      payload: { error },
    });
  }
}

function* watchDeleteLimitV2() {
  yield takeEvery(LimitConfigV2ReduxTypes.DELETE_LIMIT_V2, deleteLimitV2);
}

function* deleteLimitV2ByExternalId({ payload }: DeleteLimitV2ByExternalIdRequest): SagaIterator {
  try {
    const response = yield call(deleteLimitV2ByExternalIdApi, payload.customerExternalId, payload.borrowerLimitExternalId);
    yield put({
      type: LimitConfigV2ReduxTypes.DELETE_LIMIT_V2_BY_EXTERNAL_ID_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.DELETE_LIMIT_V2_BY_EXTERNAL_ID_ERROR,
      payload: { error },
    });
  }
}

function* watchDeleteLimitV2ByExternalId() {
  yield takeEvery(LimitConfigV2ReduxTypes.DELETE_LIMIT_V2_BY_EXTERNAL_ID, deleteLimitV2ByExternalId);
}

function* freezeLimitV2({ payload }: FreezeLimitV2Request): SagaIterator {
  try {
    const response = yield call(freezeLimitV2Api, payload.customerExternalId, payload.data);
    yield put({
      type: LimitConfigV2ReduxTypes.FREEZE_LIMIT_V2_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.FREEZE_LIMIT_V2_ERROR,
      payload: { error },
    });
  }
}

function* watchFreezeLimitV2() {
  yield takeEvery(LimitConfigV2ReduxTypes.FREEZE_LIMIT_V2, freezeLimitV2);
}

function* unfreezeLimitV2({ payload }: UnfreezeLimitV2Request): SagaIterator {
  try {
    const response = yield call(unfreezeLimitV2Api, payload.customerExternalId, payload.data);
    yield put({
      type: LimitConfigV2ReduxTypes.UNFREEZE_LIMIT_V2_SUCCESS,
      payload: { data: response.data.data },
    });
  } catch (error: any) {
    yield put({
      type: LimitConfigV2ReduxTypes.UNFREEZE_LIMIT_V2_ERROR,
      payload: { error },
    });
  }
}

function* watchUnfreezeLimitV2() {
  yield takeEvery(LimitConfigV2ReduxTypes.UNFREEZE_LIMIT_V2, unfreezeLimitV2);
}

function* limitConfigV2Saga(): SagaIterator {
  yield all([fork(watchListApprovedLimitsV2), fork(watchLatestVersionLimitsV2), fork(watchCreateDraftLimitV2), fork(watchPublishLimitV2), fork(watchUpdateDraftLimitV2), fork(watchApproveLimitV2), fork(watchRejectLimitV2), fork(watchSentBackLimitV2), fork(watchDeleteLimitV2), fork(watchDeleteLimitV2ByExternalId), fork(watchFreezeLimitV2), fork(watchUnfreezeLimitV2)]);
}

export default limitConfigV2Saga;
